export default __webpack_public_path__ + "static/media/banner-image2.c3084dcb.png";